import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { ApiUrl } from '../constants/apiUrl';
import { DeviceModel } from '../models/entities/device-model';
import { ListResponseModel } from '../models/responseModels/list-response-model';
import { ObjectResponseModel } from '../models/responseModels/object-response-model';
import { ResponseModel } from '../models/responseModels/response-model';

@Injectable({
  providedIn: 'root'
})
export class DeviceModelService {

  constructor(private httpClient: HttpClient, private router: Router, private toastrService: ToastrService) { }

  getList(): Observable<ListResponseModel<DeviceModel>> {
    return this.httpClient.get<ListResponseModel<DeviceModel>>(ApiUrl.url + "DeviceModel/getList");
  }

  getById(id: number): Observable<ObjectResponseModel<DeviceModel>> {
    return this.httpClient.get<ObjectResponseModel<DeviceModel>>(ApiUrl.url + "DeviceModel/getById?Id=" + id);
  }

  add(deviceModel: DeviceModel) {
    return this.httpClient.post<ObjectResponseModel<DeviceModel>>(ApiUrl.url + "DeviceModel/add", deviceModel);
  }

  update(deviceModel: DeviceModel) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "DeviceModel/update", deviceModel);
  }

  delete(id: number) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "DeviceModel/delete?Id=" + id, "");
  }



}
